module.exports = __webpack_public_path__ + "static/media/background.406ee09.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/background.mp4
// module id = ZaGl
// module chunks = 1